import { render } from "./PopinLeave.vue?vue&type=template&id=20bb94f4"
import script from "./PopinLeave.vue?vue&type=script&lang=js"
export * from "./PopinLeave.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__